import React, { useEffect, useState } from "react";
import { Formik, FieldArray, Field } from "formik";
import Swal from "sweetalert2";
import * as globalSettingsService from "../../../services/globalsetting.services";
import Breadcrums from "../../../common/breadcrumbs";
import {
  DT,
  handleServerValidations,
} from "../../../../../utils/commonfunction";
import { ALLOWED_VIDEO_EXTENSIONS, PHONE_NO_LENGTH, SWAL_SETTINGS, DYNAMIC_VARIABLES } from "../../../../../utils/Constants";
import Loader from "../../../common/loader";
import { URL_REGEX, amountRegex, MOBILE_NUMBER_REGEX } from "../../../../../utils/Constants";
import { useTranslation } from "react-i18next";
import * as Yup from 'yup';
import PhoneInput from "../../../../../utils/PhoneInput";
import { PHONE_VALIDATION } from "../../../../../utils/CommonValidatiobn";
import { Tooltip, Whisper } from "rsuite";

const GlobalSettings = (props) => {
  const { t } = useTranslation();
  const [showdefault, setShowDefault] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [submitClicked, setSubmitClicked] = useState(false);
  const [logoFile, setLogoFile] = useState(null);
  const [logoPreview, setLogoPreview] = useState(null);

  const [tutorialVideoFile, setTutorialVideoFile] = useState(null);
  const [tutorialVideoPreview, setTutorialVideoPreview] = useState(null);

  const [youtubeTutorialVideoFile, setYoutubeTutorialVideoFile] = useState(null);
  const [youtubeTutorialVideoPreview, setYoutubeTutorialVideoPreview] = useState(null);

  const [twitchTutorialVideoFile, setTwitchTutorialVideoFile] = useState(null);
  const [twitchTutorialVideoPreview, setTwitchTutorialVideoPreview] = useState(null);
  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    { title: t("sidebar_link_global_settings"), url: "" },
  ];
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    globalSettingsService
      .Details()
      .then((response) => {
        const data = response && response.data ? response?.data : {};
        setShowDefault(data);
        if (data?.logo) {
          const lg = data.logo;
          const fullUrl = lg.startsWith('http') || lg.startsWith('blob:')
            ? lg
            : `${DYNAMIC_VARIABLES.SERVER_URL}/uploads/settings/${lg}`;
          setLogoPreview(fullUrl);
        }
        if (data?.create_product_tutorial_video) {
          const vid = data.create_product_tutorial_video;
          const fullUrl = vid.startsWith('http') || vid.startsWith('blob:') 
            ? vid 
            : `${DYNAMIC_VARIABLES.SERVER_URL}/uploads/settings/${vid}`;
          setTutorialVideoPreview(fullUrl);
        }
        if (data?.youtube_tutorial_video) {
          const vid = data.youtube_tutorial_video;
          const fullUrl = vid.startsWith('http') || vid.startsWith('blob:') 
            ? vid 
            : `${DYNAMIC_VARIABLES.SERVER_URL}/uploads/settings/${vid}`;
          setYoutubeTutorialVideoPreview(fullUrl);
        }
        if (data?.twitch_tutorial_video) {
          const vid = data.twitch_tutorial_video;
          const fullUrl = vid.startsWith('http') || vid.startsWith('blob:') 
            ? vid 
            : `${DYNAMIC_VARIABLES.SERVER_URL}/uploads/settings/${vid}`;
          setTwitchTutorialVideoPreview(fullUrl);
        }
        setTimeout(() => {
          setDataLoaded(true);
        }, 100);
      })
      .catch((error) => {
        console.log("error=====>", error);
        setDataLoaded(true);
      });
  }, [refresh]);

  const validationSchema = Yup.object().shape({
    socialMedia: Yup.array().of(
      Yup.object().shape({
        title: Yup.string()
          .trim()
          .required('validation_err_title_required')
          .max(20, 'validation_err_reached_maximum_length'),
        icon: Yup.string()
          .trim()
          .required('validation_err_icon_required')
          .max(50, 'validation_err_reached_maximum_length'),
        link: Yup.string()
          .trim()
          .required('validation_err_link_required')
          .matches(URL_REGEX, 'invalid_web_url'),
      })
    ),
    AdminEmail: Yup.string()
      .trim()
      .required('label_email_error')
      .email('invalid_email'),

    phone_number: PHONE_VALIDATION, // Already handles trimming internally if needed

    CopyRighttxt: Yup.string()
      .trim()
      .required('copyright_error'),

    Address: Yup.string()
      .trim()
      .required('label_location_error')
      .max(100, 'validation_err_reached_maximum_length'),


    title: Yup.string()
      .trim()
      .required('label_title_error')
      .max(50, 'label_title_length_error_50'),

    play_store_url: Yup.string()
      .trim()
      .test('is-url', 'invalid_web_url', (val) => !val || URL_REGEX.test(val)),

    app_store_url: Yup.string()
      .trim()
      .test('is-url', 'invalid_web_url', (val) => !val || URL_REGEX.test(val)),

    minimum_android_version: Yup.string().trim().max(20, 'validation_err_reached_maximum_length'),
    current_android_version: Yup.string().trim().max(20, 'validation_err_reached_maximum_length'),
    minimum_ios_version: Yup.string().trim().max(20, 'validation_err_reached_maximum_length'),
    current_ios_version: Yup.string().trim().max(20, 'validation_err_reached_maximum_length'),

    description: Yup.string()
      .trim()
      .required('validation_err_description_required')
      .max(500, 'validation_err_reached_maximum_length'),

  });




  return (
    <>
      <Breadcrums data={breadcrumbs} />
      {dataLoaded ? (
        <Formik
          validateOnChange={true}
          enableReinitialize
          initialValues={{
            Address: showdefault && showdefault.address ? showdefault.address : "",

            AdminEmail: showdefault && showdefault.admin_email ? showdefault.admin_email : "",
            phone_number: showdefault && showdefault.phone_number ? showdefault.phone_number : "",
            CopyRighttxt: showdefault && showdefault.copy_right_text ? showdefault.copy_right_text : "",
            title: showdefault && showdefault.title ? showdefault.title : "",
            play_store_url: showdefault && showdefault.play_store_url ? showdefault.play_store_url : "",
            app_store_url: showdefault && showdefault.app_store_url ? showdefault.app_store_url : "",
            minimum_android_version: showdefault && showdefault.minimum_android_version ? showdefault.minimum_android_version : "",
            current_android_version: showdefault && showdefault.current_android_version ? showdefault.current_android_version : "",
            minimum_ios_version: showdefault && showdefault.minimum_ios_version ? showdefault.minimum_ios_version : "",
            current_ios_version: showdefault && showdefault.current_ios_version ? showdefault.current_ios_version : "",
            description: showdefault && showdefault.description ? showdefault.description : "",

            socialMedia: showdefault && showdefault.social_media_details && showdefault?.social_media_details?.length ? showdefault.social_media_details : [{ title: "", link: "", icon: "" }],
           
            logo: showdefault && showdefault.logo ? showdefault.logo : "",
            create_product_tutorial_video: showdefault && showdefault.create_product_tutorial_video ? showdefault.create_product_tutorial_video : "",
            youtube_tutorial_video: showdefault && showdefault.youtube_tutorial_video ? showdefault.youtube_tutorial_video : "",
            twitch_tutorial_video: showdefault && showdefault.twitch_tutorial_video ? showdefault.twitch_tutorial_video : "",
            banner_visibility: showdefault && showdefault.banner_visibility ? showdefault.banner_visibility : false,
            maintenance_mode: showdefault && showdefault.maintenance_mode ? showdefault.maintenance_mode : false,
            show_invoice: showdefault && showdefault.show_invoice ? showdefault.show_invoice : false,

            billing_company_name: showdefault?.billing_company_name ?? "THE LIVE SHOP",
            billing_subtitle: showdefault?.billing_subtitle ?? "Premium AI Streaming & Leads",
            billing_email: showdefault?.billing_email ?? "business@kalyainternational.com",
            billing_phone: showdefault?.billing_phone ?? "",
            billing_address: showdefault?.billing_address ?? "",
            billing_gst_number: showdefault?.billing_gst_number ?? "",
            billing_pan_number: showdefault?.billing_pan_number ?? "",
            cgst_rate: showdefault?.cgst_rate !== undefined ? showdefault.cgst_rate : 9,
            sgst_rate: showdefault?.sgst_rate !== undefined ? showdefault.sgst_rate : 9,
            invoice_prefix: showdefault?.invoice_prefix ?? "INV-PKG",
            invoice_starting_number: showdefault?.invoice_starting_number !== undefined ? showdefault.invoice_starting_number : 1001,
            last_invoice_number: showdefault?.last_invoice_number !== undefined ? showdefault.last_invoice_number : 1000,
          }}
          validationSchema={validationSchema}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            setSubmitted(true);

            // Trimmed version of all fields
            const trimmedValues = {
              Address: values.Address.trim(),
              AdminEmail: values.AdminEmail.trim(),
              phone_number: values.phone_number.trim(),
              CopyRighttxt: values.CopyRighttxt.trim(),
              title: values.title.trim(),
              play_store_url: (values.play_store_url || "").trim(),
              app_store_url: (values.app_store_url || "").trim(),
              minimum_android_version: (values.minimum_android_version || "").trim(),
              current_android_version: (values.current_android_version || "").trim(),
              minimum_ios_version: (values.minimum_ios_version || "").trim(),
              current_ios_version: (values.current_ios_version || "").trim(),
              description: values.description.trim(),
              billing_company_name: (values.billing_company_name || "").trim(),
              billing_subtitle: (values.billing_subtitle || "").trim(),
              billing_email: (values.billing_email || "").trim(),
              billing_phone: (values.billing_phone || "").trim(),
              billing_address: (values.billing_address || "").trim(),
              billing_gst_number: (values.billing_gst_number || "").trim(),
              billing_pan_number: (values.billing_pan_number || "").trim(),
              cgst_rate: values.cgst_rate !== "" ? Number(values.cgst_rate) : 9,
              sgst_rate: values.sgst_rate !== "" ? Number(values.sgst_rate) : 9,
              invoice_prefix: (values.invoice_prefix || "INV-PKG").trim(),
              invoice_starting_number: values.invoice_starting_number !== "" ? Number(values.invoice_starting_number) : 1001,
              last_invoice_number: values.last_invoice_number !== "" ? Number(values.last_invoice_number) : 1000,
            
              socialMedia: values.socialMedia.map((item) => ({
                title: item.title.trim(),
                link: item.link.trim(),
                icon: item.icon.trim(),
              })),
            };

            let formData = new FormData();
            formData.append("address", trimmedValues.Address);
            formData.append("admin_email", trimmedValues.AdminEmail);
            formData.append("social_media_details", JSON.stringify(trimmedValues.socialMedia));
            formData.append("phone_number", trimmedValues.phone_number);
            formData.append("copy_right_text", trimmedValues.CopyRighttxt);
            formData.append("title", trimmedValues.title);
            formData.append("play_store_url", trimmedValues.play_store_url);
            formData.append("app_store_url", trimmedValues.app_store_url);
            formData.append("minimum_android_version", trimmedValues.minimum_android_version);
            formData.append("current_android_version", trimmedValues.current_android_version);
            formData.append("minimum_ios_version", trimmedValues.minimum_ios_version);
            formData.append("current_ios_version", trimmedValues.current_ios_version);
            formData.append("description", trimmedValues.description);
            formData.append("billing_company_name", trimmedValues.billing_company_name);
            formData.append("billing_subtitle", trimmedValues.billing_subtitle);
            formData.append("billing_email", trimmedValues.billing_email);
            formData.append("billing_phone", trimmedValues.billing_phone);
            formData.append("billing_address", trimmedValues.billing_address);
            formData.append("billing_gst_number", trimmedValues.billing_gst_number);
            formData.append("billing_pan_number", trimmedValues.billing_pan_number);
            formData.append("cgst_rate", trimmedValues.cgst_rate);
            formData.append("sgst_rate", trimmedValues.sgst_rate);
            formData.append("invoice_prefix", trimmedValues.invoice_prefix);
            formData.append("invoice_starting_number", trimmedValues.invoice_starting_number);
            formData.append("last_invoice_number", trimmedValues.last_invoice_number);
            
            if (logoFile) {
              formData.append("logo", logoFile);
            } else if (values.logo !== undefined) {
              formData.append("logo", values.logo);
            }

            if (tutorialVideoFile) {
              formData.append("create_product_tutorial_video", tutorialVideoFile);
            } else if (values.create_product_tutorial_video) {
              formData.append("create_product_tutorial_video", values.create_product_tutorial_video);
            }

            if (youtubeTutorialVideoFile) {
              formData.append("youtube_tutorial_video", youtubeTutorialVideoFile);
            } else if (values.youtube_tutorial_video) {
              formData.append("youtube_tutorial_video", values.youtube_tutorial_video);
            }

            if (twitchTutorialVideoFile) {
              formData.append("twitch_tutorial_video", twitchTutorialVideoFile);
            } else if (values.twitch_tutorial_video) {
              formData.append("twitch_tutorial_video", values.twitch_tutorial_video);
            }

            formData.append("banner_visibility", values.banner_visibility);
            formData.append("maintenance_mode", values.maintenance_mode);
            formData.append("show_invoice", values.show_invoice);
         

            // console.log("formData--->",formData)
            globalSettingsService
              .Add(formData)
              .then((response) => {
                if (response.success) {
                  setRefresh((prev) => !prev);
                  Swal.fire({
                    icon: "success",
                    text: response.message,
                    ...SWAL_SETTINGS,
                  });
                  setTimeout(() => {
                    setSubmitted(false);
                  }, 2000);
                } else {
                  Swal.fire({
                    icon: "error",
                    text: handleServerValidations(response),
                    ...SWAL_SETTINGS,
                  });
                  setSubmitted(false);
                }
              })
              .catch((error) => {
                console.log("error ====> ", error);
              });
          }}
        >
          {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue, isSubmitting, setFieldTouched }) => (
            <form onSubmit={handleSubmit}>
              {/* {console.log("error", errors)} */}
              <div className="row row-sm">
                <div className="col-lg-12 col-md-12 animation_fade">
                  <div className="card custom-card">
                    <div className="card-body">
                      <div>
                        <h6 className="main-content-label mb-3">{t("sidebar_link_global_settings")}</h6>
                      </div>
                      <div className="row row-sm">
                        <div className="col-md-6 text-center form-group">
                          <label htmlFor="title" className="text-left d-flex">
                            {t("title")}:<span className="requirestar">*</span>{" "}
                            <Whisper
                              placement="top"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={<Tooltip style={{ fontWeight: "bold" }}>This title will be show as marketing website title </Tooltip>}
                            >
                              <span className="field-more-info  ms-1 cp" aria-describedby="control-id-hover">
                                ?
                              </span>
                            </Whisper>
                          </label>
                          <input name="title" type="text" id="title" onChange={handleChange} onBlur={handleBlur} value={values.title} className="form-control" placeholder={t("Enter title")} />
                          <span className="text-danger d-flex text-left">{errors.title && touched.title && t(errors.title)}</span>
                        </div>

                      

                        <div className="col-md-6 text-center form-group">
                          <label htmlFor="CopyRighttxt" className="text-left d-flex">
                            {t("label_copy_right_text")}:<span className="requirestar">*</span>{" "}
                          </label>
                          <input
                            name="CopyRighttxt"
                            type="text"
                            id="CopyRighttxt"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.CopyRighttxt}
                            className="form-control"
                            placeholder={t("Enter copy right text")}
                          />
                          <span className="text-danger d-flex text-left">{errors.CopyRighttxt && touched.CopyRighttxt && t(errors.CopyRighttxt)}</span>
                        </div>

                        <div className="col-md-6 text-center form-group">
                          <label htmlFor="AdminEmail" className="text-left d-flex">
                            {t("label_support")} {t("label_email")}:<span className="requirestar">*</span>
                          </label>
                          <input
                            name="AdminEmail"
                            type="text"
                            id="AdminEmail"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.AdminEmail}
                            className="form-control"
                            placeholder={t("placeholder_email_address")}
                          />
                          <span className="text-danger d-flex text-left">{errors.AdminEmail && touched.AdminEmail && t(errors.AdminEmail)}</span>
                        </div>

                        <div className="col-md-6 text-center form-group">
                          <label htmlFor="phone_number" className="text-left d-flex">
                            {t("label_support")} {t("label_contact_no")}:<span className="requirestar">*</span>
                          </label>
                          <PhoneInput
                            name="phone_number"
                            type="text"
                            id="phone_number"
                            onChange={(e) => {
                              setFieldValue("phone_number", e?.phone_number);
                            }}
                            // onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.phone_number}
                            className="form-control"
                            placeholder={t("web_inquiry_form_placeholder_contact_number")}
                          />
                          <span className="text-danger d-flex text-left">
                            {errors.phone_number && touched.phone_number && DT(t(errors.phone_number), { PHONE_MIN_LENGTH: PHONE_NO_LENGTH.min, PHONE_MAX_LENGTH: PHONE_NO_LENGTH.max })}
                          </span>
                        </div>

                     

                        <div className="col-md-3 text-center form-group">
                          {/* Flex container for two toggles */}
                          <div className="d-flex  align-items-center">
                            {/* Toggle One */}
                            <div className="d-flex align-items-start flex-column">
                              <label className="text-left d-flex ">Show Banners </label>
                              <label className={"custom-switch cp mt-2"  + (values.banner_visibility === true ? " e_none" : "")}>
                                <input className="custom-switch-input cp" name= "banner_visibility" type="checkbox" onChange={handleChange} onBlur={handleBlur} value={values.banner_visibility} checked={values?.banner_visibility === true} />
                                <span className="custom-switch-indicator cp"></span>
                              </label>
                            </div>

                          </div>
                        </div>
                        <div className="col-md-3 text-center form-group">
                          {/* Flex container for two toggles */}
                          <div className="d-flex  align-items-center">

                            {/* Toggle Two */}
                            <div className="d-flex align-items-start flex-column">
                              <label className="text-left d-flex">Maintenance Mode</label>
                              <label className={"custom-switch cp mt-2" + (values.maintenance_mode ===true ? " e_none" : "")}>
                                <input className="custom-switch-input cp"  name= "maintenance_mode" type="checkbox" onChange={handleChange} onBlur={handleBlur} value={values.maintenance_mode}checked={values?.maintenance_mode === true}  />
                                <span className="custom-switch-indicator cp"></span>
                              </label>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-3 text-center form-group">
                          <div className="d-flex align-items-center">
                            <div className="d-flex align-items-start flex-column">
                              <label className="text-left d-flex">Invoice</label>
                              <label className={"custom-switch cp mt-2" + (values.show_invoice === true ? " e_none" : "")}>
                                <input className="custom-switch-input cp" name="show_invoice" type="checkbox" onChange={handleChange} onBlur={handleBlur} value={values.show_invoice} checked={values?.show_invoice === true} />
                                <span className="custom-switch-indicator cp"></span>
                              </label>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6 text-center form-group">
                          <label htmlFor="play_store_url" className="text-left d-flex">
                            Play Store Url:
                          </label>
                          <input
                            name="play_store_url"
                            type="text"
                            id="play_store_url"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.play_store_url}
                            className="form-control"
                            placeholder="https://play.google.com/store/apps/details?id="
                          />
                          <span className="text-danger d-flex text-left">{errors.play_store_url && touched.play_store_url && t(errors.play_store_url)}</span>
                        </div>

                        <div className="col-md-6 text-center form-group">
                          <label htmlFor="app_store_url" className="text-left d-flex">
                            App Store Url:
                          </label>
                          <input
                            name="app_store_url"
                            type="text"
                            id="app_store_url"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.app_store_url}
                            className="form-control"
                            placeholder="https://apps.apple.com/"
                          />
                          <span className="text-danger d-flex text-left">{errors.app_store_url && touched.app_store_url && t(errors.app_store_url)}</span>
                        </div>

                        <div className="col-md-6 text-center form-group">
                          <label htmlFor="minimum_android_version" className="text-left d-flex">
                            Minimum Android Version:
                          </label>
                          <input
                            name="minimum_android_version"
                            type="text"
                            id="minimum_android_version"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.minimum_android_version}
                            className="form-control"
                            placeholder="e.g. 1.0.0"
                          />
                          <span className="text-danger d-flex text-left">{errors.minimum_android_version && touched.minimum_android_version && t(errors.minimum_android_version)}</span>
                        </div>

                        <div className="col-md-6 text-center form-group">
                          <label htmlFor="current_android_version" className="text-left d-flex">
                            Current Android Version:
                          </label>
                          <input
                            name="current_android_version"
                            type="text"
                            id="current_android_version"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.current_android_version}
                            className="form-control"
                            placeholder="e.g. 1.2.0"
                          />
                          <span className="text-danger d-flex text-left">{errors.current_android_version && touched.current_android_version && t(errors.current_android_version)}</span>
                        </div>

                        <div className="col-md-6 text-center form-group">
                          <label htmlFor="minimum_ios_version" className="text-left d-flex">
                            Minimum IOS Version:
                          </label>
                          <input
                            name="minimum_ios_version"
                            type="text"
                            id="minimum_ios_version"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.minimum_ios_version}
                            className="form-control"
                            placeholder="e.g. 1.0.0"
                          />
                          <span className="text-danger d-flex text-left">{errors.minimum_ios_version && touched.minimum_ios_version && t(errors.minimum_ios_version)}</span>
                        </div>

                        <div className="col-md-6 text-center form-group">
                          <label htmlFor="current_ios_version" className="text-left d-flex">
                            Current IOS Version:
                          </label>
                          <input
                            name="current_ios_version"
                            type="text"
                            id="current_ios_version"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.current_ios_version}
                            className="form-control"
                            placeholder="e.g. 1.2.0"
                          />
                          <span className="text-danger d-flex text-left">{errors.current_ios_version && touched.current_ios_version && t(errors.current_ios_version)}</span>
                        </div>

                        <div className="col-md-12 text-center form-group">
                          <label htmlFor="description" className="text-left d-flex">
                            {t("label_description", "Description")}:<span className="requirestar">*</span>{" "}
                          </label>
                          <textarea
                            name="description"
                            id="description"
                            type="text"
                            style={{ minHeight: "100px" }}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.description}
                            className="form-control"
                            placeholder={t("Enter description")}
                          />
                          <span className="text-danger d-flex text-left">{errors.description && touched.description && t(errors.description)}</span>
                        </div>

                        <div className="col-md-12 text-center form-group">
                          <label htmlFor="Address" className="text-left d-flex">
                            {t("label_support")} {t("list_heading_address")}:<span className="requirestar">*</span>{" "}
                          </label>
                          <textarea
                            name="Address"
                            id="Address"
                            type="text"
                            style={{ minHeight: "100px" }}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.Address}
                            className="form-control"
                            placeholder={t("placeholder_address")}
                          />
                          <span className="text-danger d-flex text-left">{errors.Address && touched.Address && t(errors.Address)}</span>
                        </div>

                        <div className="col-md-12 text-center form-group">
                          <label className="text-left d-flex font-weight-bold">
                            {t("Logo / Invoice Logo") || "Logo / Invoice Logo"}:
                          </label>
                          <div className="d-flex flex-column align-items-start gap-2">
                            <input
                              type="file"
                              accept="image/png, image/jpeg, image/jpg, image/webp, image/svg+xml"
                              className="form-control"
                              onChange={(e) => {
                                const file = e.target.files && e.target.files[0];
                                if (file) {
                                  setLogoFile(file);
                                  setLogoPreview(URL.createObjectURL(file));
                                  setFieldValue("logo", file.name);
                                }
                              }}
                            />
                            <small className="text-muted text-left mt-1">
                              Upload a logo image (.png, .jpg, .webp). This logo will be used for invoices and site branding instead of the default text logo.
                            </small>
                            {logoPreview && (
                              <div className="mt-3 w-100 text-left">
                                <p className="mb-1 font-weight-semibold">Logo Preview:</p>
                                <div style={{ maxWidth: "260px", padding: "12px", background: "#f8f9fa", borderRadius: "8px", border: "1px solid #dee2e6" }} className="position-relative">
                                  <img
                                    src={logoPreview}
                                    alt="Logo Preview"
                                    className="img-fluid rounded"
                                    style={{ maxHeight: "80px", maxWidth: "100%", objectFit: "contain", display: "block" }}
                                  />
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-danger mt-2"
                                    onClick={() => {
                                      setLogoFile(null);
                                      setLogoPreview(null);
                                      setFieldValue("logo", "");
                                    }}
                                  >
                                    Remove Logo
                                  </button>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="col-md-12 text-center form-group">
                          <label className="text-left d-flex font-weight-bold">
                            {t("Create Product Tutorial Video") || "Create Product Tutorial Video"}:
                          </label>
                          <div className="d-flex flex-column align-items-start gap-2">
                            <input
                              type="file"
                              accept="video/*"
                              className="form-control"
                              onChange={(e) => {
                                const file = e.target.files && e.target.files[0];
                                if (file) {
                                  setTutorialVideoFile(file);
                                  setTutorialVideoPreview(URL.createObjectURL(file));
                                  setFieldValue("create_product_tutorial_video", file.name);
                                }
                              }}
                            />
                            <small className="text-muted text-left mt-1">
                              Upload a video file (.mp4, .webm, .mov) for the product creation tutorial.
                            </small>
                            {tutorialVideoPreview && (
                              <div className="mt-3 w-100 text-left">
                                <p className="mb-1 font-weight-semibold">Video Preview:</p>
                                <div style={{ maxWidth: "450px" }} className="position-relative">
                                  <video
                                    controls
                                    src={tutorialVideoPreview}
                                    className="w-100 rounded border shadow-sm"
                                    style={{ maxHeight: "250px", backgroundColor: "#000" }}
                                  />
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-danger mt-2"
                                    onClick={() => {
                                      setTutorialVideoFile(null);
                                      setTutorialVideoPreview(null);
                                      setFieldValue("create_product_tutorial_video", "");
                                    }}
                                  >
                                    Remove Video
                                  </button>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="col-md-12 text-center form-group">
                          <label className="text-left d-flex font-weight-bold">
                            {t("Create You Tube Setup Guide Video") || "Create You Tube Setup Guide Video"}:
                          </label>
                          <div className="d-flex flex-column align-items-start gap-2">
                            <input
                              type="file"
                              accept="video/*"
                              className="form-control"
                              onChange={(e) => {
                                const file = e.target.files && e.target.files[0];
                                if (file) {
                                  setYoutubeTutorialVideoFile(file);
                                  setYoutubeTutorialVideoPreview(URL.createObjectURL(file));
                                  setFieldValue("youtube_tutorial_video", file.name);
                                }
                              }}
                            />
                            <small className="text-muted text-left mt-1">
                              Upload a video file (.mp4, .webm, .mov) for the YouTube streaming tutorial.
                            </small>
                            {youtubeTutorialVideoPreview && (
                              <div className="mt-3 w-100 text-left">
                                <p className="mb-1 font-weight-semibold">Video Preview:</p>
                                <div style={{ maxWidth: "450px" }} className="position-relative">
                                  <video
                                    controls
                                    src={youtubeTutorialVideoPreview}
                                    className="w-100 rounded border shadow-sm"
                                    style={{ maxHeight: "250px", backgroundColor: "#000" }}
                                  />
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-danger mt-2"
                                    onClick={() => {
                                      setYoutubeTutorialVideoFile(null);
                                      setYoutubeTutorialVideoPreview(null);
                                      setFieldValue("youtube_tutorial_video", "");
                                    }}
                                  >
                                    Remove Video
                                  </button>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="col-md-12 text-center form-group">
                          <label className="text-left d-flex font-weight-bold">
                            {t("Create Twitch Tutorial Video") || "Create Twitch Tutorial Video"}:
                          </label>
                          <div className="d-flex flex-column align-items-start gap-2">
                            <input
                              type="file"
                              accept="video/*"
                              className="form-control"
                              onChange={(e) => {
                                const file = e.target.files && e.target.files[0];
                                if (file) {
                                  setTwitchTutorialVideoFile(file);
                                  setTwitchTutorialVideoPreview(URL.createObjectURL(file));
                                  setFieldValue("twitch_tutorial_video", file.name);
                                }
                              }}
                            />
                            <small className="text-muted text-left mt-1">
                              Upload a video file (.mp4, .webm, .mov) for the Twitch streaming tutorial.
                            </small>
                            {twitchTutorialVideoPreview && (
                              <div className="mt-3 w-100 text-left">
                                <p className="mb-1 font-weight-semibold">Video Preview:</p>
                                <div style={{ maxWidth: "450px" }} className="position-relative">
                                  <video
                                    controls
                                    src={twitchTutorialVideoPreview}
                                    className="w-100 rounded border shadow-sm"
                                    style={{ maxHeight: "250px", backgroundColor: "#000" }}
                                  />
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-danger mt-2"
                                    onClick={() => {
                                      setTwitchTutorialVideoFile(null);
                                      setTwitchTutorialVideoPreview(null);
                                      setFieldValue("twitch_tutorial_video", "");
                                    }}
                                  >
                                    Remove Video
                                  </button>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>

                        <label className="text-left d-flex">{t("label_social_media")}:</label>
                        <FieldArray
                          name="socialMedia"
                          render={(arrayHelper) => (
                            <div className="col-12 mb-4">
                              <div className="row">
                                {values?.socialMedia && values?.socialMedia?.length >= 0 ? (
                                  values?.socialMedia.map((item, index) => (
                                    <div className="col-12 " key={index}>
                                      <div className="w-100 p-2 bg-group">
                                        <div className="row">
                                          <div className="col-md-3 text-center form-group mb-0">
                                            <Field
                                              className="form-control"
                                              id="title"
                                              name={`socialMedia[${index}].title`}
                                              onChange={handleChange}
                                              onBlur={handleBlur}
                                              value={item.title}
                                              placeholder={t("input_placeholder_title")}
                                            />
                                            <span className="text-danger d-flex text-left">
                                              {((touched?.socialMedia && touched?.socialMedia[index] && touched?.socialMedia[index].title) || submitClicked) &&
                                                errors.socialMedia &&
                                                errors.socialMedia[index] &&
                                                t(errors.socialMedia[index].title)}
                                            </span>
                                          </div>
                                          <div className="col-md-4 text-center form-group mb-0">
                                            <Field
                                              className="form-control"
                                              id="link"
                                              name={`socialMedia[${index}].link`}
                                              onChange={handleChange}
                                              onBlur={handleBlur}
                                              value={item.link}
                                              placeholder={t("input_placeholder_link")}
                                            />
                                            <span className="text-danger d-flex text-left">
                                              {((touched.socialMedia && touched.socialMedia[index] && touched.socialMedia[index].link) || submitClicked) &&
                                                errors.socialMedia &&
                                                errors.socialMedia[index] &&
                                                t(errors.socialMedia[index].link)}
                                            </span>
                                          </div>
                                          <div className="col-md-3 text-center form-group mb-0">
                                            <Field
                                              className="form-control"
                                              id="icon"
                                              name={`socialMedia[${index}].icon`}
                                              onChange={handleChange}
                                              onBlur={handleBlur}
                                              value={item.icon}
                                              placeholder={t("input_placeholder_icon")}
                                            />
                                            <span className="text-danger d-flex text-left">
                                              {((touched.socialMedia && touched.socialMedia[index] && touched.socialMedia[index].icon) || submitClicked) &&
                                                errors.socialMedia &&
                                                errors.socialMedia[index] &&
                                                t(errors.socialMedia[index].icon)}
                                            </span>
                                          </div>
                                          <div className="col-md-2">
                                            <div className="social-media-action">
                                              <button
                                                className="btn btn-danger "
                                                type="button"
                                                disabled={values?.socialMedia?.length === 1}
                                                onClick={() => arrayHelper.remove(index)} // remove a friend from the list
                                              >
                                                {t("link_remove")}
                                              </button>
                                              {index === values?.socialMedia?.length - 1 && (
                                                <button
                                                  className="btn btn-main-primary signbtn ms-2 "
                                                  type="button"
                                                  onClick={() =>
                                                    arrayHelper.insert(values?.socialMedia?.length, {
                                                      title: "",
                                                      link: "",
                                                      icon: "",
                                                    })
                                                  }
                                                >
                                                  {t("link_add")}
                                                </button>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ))
                                ) : (
                                  <button className="btn btn-main-primary signbtn mr-2 ms-2 mb-3" type="button" onClick={() => arrayHelper.push({})}>
                                    Add a social media
                                  </button>
                                )}
                              </div>
                            </div>
                          )}
                        />

                        <div className="col-12 mt-4 mb-3">
                          <hr className="my-4" />
                          <div className="d-flex align-items-center justify-content-between mb-2">
                            <div>
                              <h5 className="font-weight-bold text-primary mb-1">
                                <i className="fa fa-file-text-o me-2"></i> Owner Billing & Tax Details (Invoice Mapping)
                              </h5>
                              <p className="text-muted small mb-0">
                                Configure the company details and CGST/SGST tax rates mapped directly to generated customer invoices.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6 text-center form-group">
                          <label htmlFor="billing_company_name" className="text-left d-flex font-weight-semibold">
                            Company / Trade Name:
                          </label>
                          <input
                            name="billing_company_name"
                            type="text"
                            id="billing_company_name"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.billing_company_name}
                            className="form-control"
                            placeholder="e.g. THE LIVE SHOP"
                          />
                        </div>

                        <div className="col-md-6 text-center form-group">
                          <label htmlFor="billing_subtitle" className="text-left d-flex font-weight-semibold">
                            Invoice Tagline / Subtitle:
                          </label>
                          <input
                            name="billing_subtitle"
                            type="text"
                            id="billing_subtitle"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.billing_subtitle}
                            className="form-control"
                            placeholder="e.g. Premium AI Streaming & Leads"
                          />
                        </div>

                        <div className="col-md-6 text-center form-group">
                          <label htmlFor="billing_email" className="text-left d-flex font-weight-semibold">
                            Billing & Business Email:
                          </label>
                          <input
                            name="billing_email"
                            type="email"
                            id="billing_email"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.billing_email}
                            className="form-control"
                            placeholder="e.g. business@kalyainternational.com"
                          />
                        </div>

                        <div className="col-md-6 text-center form-group">
                          <label htmlFor="billing_phone" className="text-left d-flex font-weight-semibold">
                            Billing Contact Phone:
                          </label>
                          <input
                            name="billing_phone"
                            type="text"
                            id="billing_phone"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.billing_phone}
                            className="form-control"
                            placeholder="e.g. +91 9876543210"
                          />
                        </div>

                        <div className="col-md-6 text-center form-group">
                          <label htmlFor="billing_gst_number" className="text-left d-flex font-weight-semibold">
                            Owner GSTIN:
                          </label>
                          <input
                            name="billing_gst_number"
                            type="text"
                            id="billing_gst_number"
                            onChange={(e) => {
                              const val = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "");
                              setFieldValue("billing_gst_number", val);
                            }}
                            onBlur={handleBlur}
                            value={values.billing_gst_number}
                            className="form-control"
                            placeholder="e.g. 29ABCDE1234F1Z5"
                            maxLength={15}
                            style={{ textTransform: "uppercase" }}
                          />
                        </div>

                        <div className="col-md-6 text-center form-group">
                          <label htmlFor="billing_pan_number" className="text-left d-flex font-weight-semibold">
                            Owner PAN Number:
                          </label>
                          <input
                            name="billing_pan_number"
                            type="text"
                            id="billing_pan_number"
                            onChange={(e) => {
                              const val = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "");
                              setFieldValue("billing_pan_number", val);
                            }}
                            onBlur={handleBlur}
                            value={values.billing_pan_number}
                            className="form-control"
                            placeholder="e.g. ABCDE1234F"
                            maxLength={10}
                            style={{ textTransform: "uppercase" }}
                          />
                        </div>

                        <div className="col-md-12 text-center form-group">
                          <label htmlFor="billing_address" className="text-left d-flex font-weight-semibold">
                            Owner Billing Address:
                          </label>
                          <textarea
                            name="billing_address"
                            id="billing_address"
                            style={{ minHeight: "80px" }}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.billing_address}
                            className="form-control"
                            placeholder="Enter business billing address for invoices"
                          />
                        </div>

                        {/* Tax Rates (CGST & SGST) */}
                        <div className="col-md-6 text-center form-group">
                          <label htmlFor="cgst_rate" className="text-left d-flex font-weight-semibold">
                            CGST Rate (%):
                          </label>
                          <div className="input-group">
                            <input
                              name="cgst_rate"
                              type="number"
                              id="cgst_rate"
                              min="0"
                              max="100"
                              step="0.01"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.cgst_rate}
                              className="form-control"
                              placeholder="9"
                            />
                            <span className="input-group-text">%</span>
                          </div>
                        </div>

                        <div className="col-md-6 text-center form-group">
                          <label htmlFor="sgst_rate" className="text-left d-flex font-weight-semibold">
                            SGST Rate (%):
                          </label>
                          <div className="input-group">
                            <input
                              name="sgst_rate"
                              type="number"
                              id="sgst_rate"
                              min="0"
                              max="100"
                              step="0.01"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.sgst_rate}
                              className="form-control"
                              placeholder="9"
                            />
                            <span className="input-group-text">%</span>
                          </div>
                        </div>

                        {/* Invoice Numbering Sequence */}
                        <div className="col-12 mt-3 mb-2">
                          <h6 className="font-weight-bold text-dark border-bottom pb-2">
                            <i className="fa fa-list-ol me-2 text-primary"></i> Invoice Numbering Sequence
                          </h6>
                        </div>

                        <div className="col-md-4 text-center form-group">
                          <label htmlFor="invoice_prefix" className="text-left d-flex font-weight-semibold">
                            Invoice Prefix:
                          </label>
                          <input
                            name="invoice_prefix"
                            type="text"
                            id="invoice_prefix"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.invoice_prefix}
                            className="form-control"
                            placeholder="e.g. INV-PKG"
                          />
                        </div>

                        <div className="col-md-4 text-center form-group">
                          <label htmlFor="invoice_starting_number" className="text-left d-flex font-weight-semibold">
                            Starting Number:
                          </label>
                          <input
                            name="invoice_starting_number"
                            type="number"
                            id="invoice_starting_number"
                            min="1"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.invoice_starting_number}
                            className="form-control"
                            placeholder="e.g. 1001"
                          />
                        </div>

                        <div className="col-md-4 text-center form-group">
                          <label htmlFor="last_invoice_number" className="text-left d-flex font-weight-semibold">
                            Last Generated Number:
                          </label>
                          <input
                            name="last_invoice_number"
                            type="number"
                            id="last_invoice_number"
                            min="0"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.last_invoice_number}
                            className="form-control"
                            placeholder="e.g. 1000"
                          />
                        </div>

                        <div className="col-12 mb-3">
                          <div className="p-2 bg-white rounded border d-flex align-items-center justify-content-between">
                            <span className="text-muted small">
                              <i className="fa fa-arrow-circle-right text-success me-1"></i> Next Invoice will be generated as:
                            </span>
                            <span className="badge bg-primary text-white font-weight-bold p-2" style={{ fontSize: "13px" }}>
                              {(values.invoice_prefix || "INV-PKG")}-{Math.max(Number(values.invoice_starting_number || 1001), Number(values.last_invoice_number || 0) + 1)}
                            </span>
                          </div>
                        </div>

                        <div className="col-12 mb-4">
                          <div className="p-3 bg-light rounded border">
                            <small className="text-dark d-block font-weight-semibold mb-1">
                              <i className="fa fa-info-circle text-primary me-1"></i> GST Calculation Example:
                            </small>
                            <small className="text-muted">
                              For a ₹100 GST-inclusive package at {values.cgst_rate || 9}% CGST and {values.sgst_rate || 9}% SGST:
                              <br />
                              • Base Price: <strong>₹{(100 / (1 + ((Number(values.cgst_rate || 9) + Number(values.sgst_rate || 9)) / 100))).toFixed(2)}</strong>
                              <br />
                              • CGST Incl. ({values.cgst_rate || 9}%): <strong>₹{(((100 - Number((100 / (1 + ((Number(values.cgst_rate || 9) + Number(values.sgst_rate || 9)) / 100))).toFixed(2))) * Number(values.cgst_rate || 9)) / (Number(values.cgst_rate || 9) + Number(values.sgst_rate || 9))).toFixed(2)}</strong>
                              <br />
                              • SGST Incl. ({values.sgst_rate || 9}%): <strong>₹{(100 - Number((100 / (1 + ((Number(values.cgst_rate || 9) + Number(values.sgst_rate || 9)) / 100))).toFixed(2)) - Number((((100 - Number((100 / (1 + ((Number(values.cgst_rate || 9) + Number(values.sgst_rate || 9)) / 100))).toFixed(2))) * Number(values.cgst_rate || 9)) / (Number(values.cgst_rate || 9) + Number(values.sgst_rate || 9))).toFixed(2))).toFixed(2)}</strong>
                              <br />
                              • Total Invoice Amount: <strong>₹100.00</strong>
                            </small>
                          </div>
                        </div>

                        {/* {hasPermission("/admin/cms/settings/submit") ? ( */}
                        <div className="">
                          <button
                            className="btn btn-main-primary signbtn mr-2"
                            type="submit"
                            disabled={submitted ? true : null}
                            onClick={() => {
                              setSubmitClicked(true);
                            }}
                          >
                            <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                            {t("btn_submit")}
                          </button>
                        </div>
                        {/* ) : null} */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          )}
        </Formik>
      ) : (
        <Loader />
      )}
    </>
  );
};

export default GlobalSettings;


